import React, { useContext, useRef, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "font-awesome/css/font-awesome.min.css";
import { MyContext } from "../../MyContextApi";
import { Link } from "react-router-dom";
import BarChart from "./Barchart";
import { jwtDecode } from "jwt-decode"; // Corrected import statement
import getTrendingHashtags from "../../API/hashtags";

import {
  countPlatforms,
  countSections,
  countSentiment,
  countLanguages,
} from "./Pdfhelper";

import TextAnalysisTable from "../UserLevel/TextAnalysisTable";
import { TailSpin } from "react-loader-spinner";
import "./../../styles/App.css";
import PieChart from "./PieChart";
import ReportWorldCloud from "./ReportWorldCloud";
import { PrintReport } from "./printReport";
import ReportCylinderChart from "../ReportCylinderChart";
import TextAnalysisTableNews from "../UserLevel/TextAnalysisTableNews";
import { PrintReportNews } from "./printReportNews";
import ImageAnalysisTable from "../UserLevel/ImageAnalysisTable";
import { PrintImageReport } from "./printImageReport";
import { generateHash } from "../../API/hashUtil";
import axios from "axios";
import { Button } from "@mui/material";
import FakeNewsDataGrid from "../UserLevel/DataGrid";
import PrintFakeNews from "./PrintFakeNews";
import getHashtagsBySession from "../../API/hashtagsBySession";
import SessionWordCloud from "./SessionWordCloud";
import SentimentAnalysisTable from "../UserLevel/SentimentAnalysisTable";
import { PrintSentimentReport } from "./PrintSentimentReport";
import { reportsProxyUrl } from "../../API/axiosInstance";

const apiUrl = process.env.REACT_APP_BASE_API_URL;
const reportsApiUrl = reportsProxyUrl();
const PreviewReport = () => {
  const {
    apiSelect,
    toggleButton,
    settoggleButton,
    serverresponse,
    setServerResponse,
    analyticsData,
    selectedPlatforms,
    isCompleted,
    isLoading,
    setIsCompleted,
    setIsLoading,
    pdfToSimple,
    setpdfToSimple,
    pdfFromSimple,
    NewsCount,
    startDateStr,
    endDateStr,
    selectedRange,
    reporttoDateTimeFormatted,
    reportfromDateTimeFormatted,
    isDownload,
    setIsDownload,
    sentimentSummary,
  } = useContext(MyContext);

  const [pdfTrend, setpdfTrend] = useState(null);

  const [pieChartData, setPieChartData] = useState({
    platform: { labels: [], values: [] },
    section: { labels: [], values: [] },
    sentiment: { labels: [], values: [] },
    languages: { labels: [], values: [] },
  });

  const token = localStorage.getItem("Token");
  const decodedToken = jwtDecode(token);
  const userName = decodedToken.username;

  const pieChartRef = useRef(null);
  const sectionPieChartRef = useRef(null);
  const sentimentPieChartRef = useRef(null);
  const barChartRef = useRef(null);
  const wordCloudRef = useRef(null);
  const tableRef = useRef(null);
  const location = useLocation();
  const sessionID = location.state?.sessionID || "";
  const dateCreated = location.state?.dateCreated || "";

  // Force window size on component mount
  useEffect(() => {
    const setWindowSize = () => {
      // Option 1: Try to resize the current window (may not work in all browsers)
      try {
        window.resizeTo(1530, 836);
      } catch (error) {
        console.warn("Window resize not allowed by browser:", error);
      }

      // Option 2: Open in a new window with specific dimensions (alternative approach)
      // Uncomment this if you want to open in a new window instead
      /*
      const newWindow = window.open(
        window.location.href,
        '_blank',
        'width=1530,height=836,resizable=yes,scrollbars=yes'
      );
      if (newWindow) {
        window.close(); // Close current window
      }
      */
    };

    setWindowSize();
  }, []);

  useEffect(() => {
    if (
      location.state &&
      location.state.AnalysisSessionData &&
      location.state.AnalysisSessionData.length > 0
    ) {
      const { AnalysisSessionData } = location.state;
      setServerResponse(AnalysisSessionData);
    }
  }, [location.state]);

  useEffect(() => {
    const token = localStorage.getItem("Token");

    const stringParams = {
      startDateStr: reportfromDateTimeFormatted?.toString() || "",
      endDateStr: reporttoDateTimeFormatted?.toString() || "",
    };
    const hexHash = generateHash(stringParams);

    if (sessionID && apiSelect.value === "api/filter") {
      setpdfToSimple(dateCreated);

      getHashtagsBySession(token, sessionID, hexHash)
        .then((data) => setpdfTrend(data.data))
        .catch((error) =>
          console.error("Error fetching session hashtags:", error)
        );
    }

    if (sessionID && apiSelect.value === "api/socialSentiments") {
      setpdfToSimple(dateCreated);
    } else if (apiSelect.value === "api/filter") {
      getTrendingHashtags(
        token,
        reportfromDateTimeFormatted,
        reporttoDateTimeFormatted,
        hexHash
      )
        .then((data) => setpdfTrend(data.data))
        .catch((error) =>
          console.error("Error fetching trending hashtags:", error)
        );
    }
  }, [
    sessionID,
    apiSelect,
    reportfromDateTimeFormatted,
    reporttoDateTimeFormatted,
  ]);

  useEffect(() => {
    const platformCounts = countPlatforms(serverresponse, analyticsData);
    const sectionCounts = countSections(serverresponse, analyticsData);
    const sentimentCounts = countSentiment(serverresponse, analyticsData);
    const languagesCounts = countLanguages(serverresponse, analyticsData);
    const token = localStorage.getItem("Token");

    setIsCompleted(false);

    const platformLabels = Object.keys(platformCounts);
    const platformValues = platformLabels.map(
      (platform) => platformCounts[platform]
    );

    const languagesLabels = Object.keys(languagesCounts);
    const languagesValues = languagesLabels.map(
      (lang) => languagesCounts[lang]
    );

    const sentimentLabels = Object.keys(sentimentCounts);
    const sentimentValues = sentimentLabels.map(
      (sentiment) => sentimentCounts[sentiment]
    );

    const sectionLabels = Object.keys(sectionCounts);
    const sectionValues = sectionLabels.map(
      (section) => sectionCounts[section]
    );

    setPieChartData({
      platform: { labels: platformLabels, values: platformValues },
      section: { labels: sectionLabels, values: sectionValues },
      sentiment: { labels: sentimentLabels, values: sentimentValues },
      languages: { labels: languagesLabels, values: languagesValues },
    });
  }, [serverresponse, analyticsData]);

  // Extract unique platform names
  const reportPlatforms = [
    ...new Set(
      serverresponse ? serverresponse.map((response) => response.platform) : []
    ),
  ];

  const getCurrentDateTime = () => {
    const now = new Date();

    // Get date parts
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    // Always use milliseconds as .000
    const milliseconds = "000";

    // Always use +00:00 for UTC
    const timezoneOffset = "+00:00";

    // Construct the datetime string in the required format
    const formattedDateTime = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}${timezoneOffset}`;

    return formattedDateTime;
  };

  const handleDownloadHistory = () => {
    const reportType = apiSelect.label;

    const payload = {
      platform: reportPlatforms,
      startDate: reportfromDateTimeFormatted,
      endDate: reporttoDateTimeFormatted,
      reportType: reportType,
      date: getCurrentDateTime(),
      username: userName,
    };

    axios
      .post(`${apiUrl}/user/saveDetails`, payload, {
        headers: {
          // Security Headers
          "X-XSS-Protection": "1; mode=block",
          Authorization: `Bearer ${token}`,
          "X-Content-Type-Options": "nosniff",
          "X-Frame-Options": "DENY",
          "Referrer-Policy": "strict-origin-when-cross-origin",
          "Permissions-Policy": "camera=(), microphone=(), geolocation=()",

          // Standard Headers
          "Content-Type": "application/json",
        },
      })
      .then((response) => {})
      .catch((error) => {
        console.error("Error sending data to server:", error);
      });
  };

  const handlePrint = () => {
    if (isDownload === false) {
      handleDownloadHistory();
    }

    PrintReport(
      serverresponse,
      analyticsData,
      pieChartRef,
      sectionPieChartRef,
      sentimentPieChartRef,
      selectedPlatforms,
      barChartRef,
      wordCloudRef,
      setIsCompleted,
      setIsLoading,
      pdfToSimple,
      pdfFromSimple
    );
  };

  const handlePrintNews = () => {
    if (isDownload === false) {
      handleDownloadHistory();
    }

    PrintReportNews(
      serverresponse,
      analyticsData,
      pieChartRef,
      sectionPieChartRef,
      sentimentPieChartRef,
      selectedPlatforms,
      barChartRef,
      wordCloudRef,
      setIsCompleted,
      setIsLoading,
      pdfToSimple,
      pdfFromSimple,
      NewsCount
    );
  };

  const handlePrintImageReport = async () => {
    if (isDownload === false) {
      handleDownloadHistory();
    }
    try {
      setIsLoading(true);
      const response = await fetch(`${reportsApiUrl}/image-analysis`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",

        },
        body: JSON.stringify({
          // sessionId: "68873c7986df9d6b129503e6",
          startDate: reportfromDateTimeFormatted,
          endDate: reporttoDateTimeFormatted,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to generate PDF");
      }

      const blob = await response.blob();

      // ✅ Get filename from backend headers (fallback if missing)
      let filename = "CSMART_Image_Analysis_Report.pdf";
      const contentDisposition = response.headers.get("Content-Disposition");
      if (contentDisposition && contentDisposition.includes("filename=")) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match?.[1]) filename = match[1];
      }

      // ✅ Trigger file download
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);

      setIsCompleted(true);
    } catch (err) {
      setIsLoading(false);
      console.error("Error downloading PDF:", err);
      alert("Something went wrong while downloading the report!");
    }

    // PrintImageReport(
    //   serverresponse,
    //   selectedPlatforms,
    //   setIsCompleted,
    //   setIsLoading,
    //   pdfToSimple,
    //   pdfFromSimple,
    //   setIsLoading
    // );
  };

  const handlePrintFakeNews = () => {
    if (isDownload === false) {
      handleDownloadHistory();
    }

    PrintFakeNews(
      serverresponse,
      pdfToSimple,
      setIsCompleted,
      setIsLoading,
      pdfToSimple,
      pdfFromSimple,
      setIsLoading
    );
  };

  const handlePrintSocialsentiments = () => {
    if (isDownload === false) {
      handleDownloadHistory();
    }
    PrintSentimentReport(
      serverresponse,
      pieChartRef,
      sectionPieChartRef,
      sentimentPieChartRef,
      selectedPlatforms,
      barChartRef,
      wordCloudRef,
      setIsCompleted,
      setIsLoading,
      pdfToSimple,
      pdfFromSimple,
      sentimentSummary
    );
  };

  useEffect(() => {
    const hashtagsCount = {};
    let hasHashtags = false;

    if (apiSelect.value === "api/socialSentiments") {
      serverresponse &&
        serverresponse.forEach((item) => {
          if (
            item.hashtags &&
            Array.isArray(item.hashtags) &&
            item.hashtags.length > 0
          ) {
            item.hashtags.forEach((tag) => {
              const trimmedTag = tag.trim();
              if (trimmedTag) {
                hasHashtags = true;
                if (hashtagsCount[trimmedTag]) {
                  hashtagsCount[trimmedTag] += 1;
                } else {
                  hashtagsCount[trimmedTag] = 1;
                }
              }
            });
          }
        });

      // If no hashtags were found, use keywords instead
      if (!hasHashtags) {
        serverresponse &&
          serverresponse.forEach((item) => {
            if (item.keyword) {
              const trimmedKeyword = item.keyword.trim();
              if (trimmedKeyword) {
                hashtagsCount[trimmedKeyword] = 1; // Always set to 1, don't increment
              }
            }
          });
      }

      setpdfTrend(hashtagsCount);
    }
  }, [serverresponse]);

  useEffect(() => {
    const metaTag = document.createElement("meta");
    metaTag.name = "viewport";
    metaTag.content =
      "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no";
    document.head.appendChild(metaTag);

    const preventZoom = (e) => {
      if (e.ctrlKey || e.metaKey || e.key === "+" || e.key === "-") {
        e.preventDefault();
      }
    };

    const preventMouseWheelZoom = (e) => {
      if (e.ctrlKey || e.metaKey) {
        e.preventDefault();
      }
    };

    window.addEventListener("keydown", preventZoom);
    window.addEventListener("wheel", preventMouseWheelZoom);

    return () => {
      document.head.removeChild(metaTag);
      window.removeEventListener("keydown", preventZoom);
      window.removeEventListener("wheel", preventMouseWheelZoom);
    };
  }, []);

  return (
    // Container with fixed dimensions
    <div
      style={{
        width: "1530px",
        height: "836px",
        overflow: "auto",
        margin: "0 auto",
        position: "relative",
      }}
    >
      <nav
        style={{
          height: "74px",
          display: "block",
          // borderBottom: "2px solid black",
          backgroundColor: "#FFFFFF",
        }}
      >
        <div
          id="firstpartnav"
          style={{ height: "74px", justifyContent: "center" }}
        >
          {isLoading && (
            <div className="alert loading">
              <TailSpin
                height={25}
                width={25}
                color="blue"
                ariaLabel="loading"
              />
              <span>Download in progress.....</span>
            </div>
          )}
          {isCompleted && (
            <div className="alert completed">
              <span> Download completed 🎉!</span>
            </div>
          )}
          {apiSelect.value === "api/filter" ? (
            <Button
              variant="contained"
              onClick={handlePrint}
              className="stunning-button"
              sx={{
                "&.MuiButton-root": {
                  fontFamily: "'Host Grotesk', sans-serif",
                  fontSize: "14px",
                  fontWeight: "700",
                  padding: "22px 24px",
                  background:
                    "linear-gradient(135deg, #1AACAC 0%, #138B8B 100%)",
                  color: "white",
                  borderRadius: "8px",
                  border: "none",
                  boxShadow: "0 4px 15px rgba(26, 172, 172, 0.2)",
                  transition: "all 0.3s ease",

                  "&:hover": {
                    background:
                      "linear-gradient(135deg, #1AACAC 0%, #138B8B 100%)",
                    transform: "translateY(-2px)",
                    boxShadow: "0 6px 20px rgba(26, 172, 172, 0.3)",
                  },

                  "&:active": {
                    transform: "translateY(0)",
                    boxShadow: "0 2px 10px rgba(26, 172, 172, 0.2)",
                  },
                },
              }}
            >
              Confirm And Download
            </Button>
          ) : apiSelect.value === "news/report" ? (
            <Button
              variant="outlined"
              onClick={handlePrintNews}
              className="stunning-button"
              sx={{
                "&.MuiButton-root": {
                  fontFamily: "'Host Grotesk', sans-serif",
                  fontSize: "14px",
                  fontWeight: "700",
                  padding: "22px 24px",
                  background:
                    "linear-gradient(135deg, #1AACAC 0%, #138B8B 100%)",
                  color: "white",
                  borderRadius: "8px",
                  border: "none",
                  boxShadow: "0 4px 15px rgba(26, 172, 172, 0.2)",
                  transition: "all 0.3s ease",
                  marginBottom: "8px", // Added margin-bottom

                  "&:hover": {
                    background:
                      "linear-gradient(135deg, #1AACAC 0%, #138B8B 100%)",
                    transform: "translateY(-2px)",
                    boxShadow: "0 6px 20px rgba(26, 172, 172, 0.3)",
                  },

                  "&:active": {
                    transform: "translateY(0)",
                    boxShadow: "0 2px 10px rgba(26, 172, 172, 0.2)",
                  },
                },
              }}
            >
              Confirm And Download
            </Button>
          ) : apiSelect.value === "api/images" ? (
            <Button
              variant="outlined"
              onClick={handlePrintImageReport}
              className="stunning-button"
              sx={{
                "&.MuiButton-root": {
                  fontFamily: "'Host Grotesk', sans-serif",
                  fontSize: "14px",
                  fontWeight: "700",
                  padding: "22px 24px",
                  background:
                    "linear-gradient(135deg, #1AACAC 0%, #138B8B 100%)",
                  color: "white",
                  borderRadius: "8px",
                  border: "none",
                  boxShadow: "0 4px 15px rgba(26, 172, 172, 0.2)",
                  transition: "all 0.3s ease",

                  "&:hover": {
                    background:
                      "linear-gradient(135deg, #1AACAC 0%, #138B8B 100%)",
                    transform: "translateY(-2px)",
                    boxShadow: "0 6px 20px rgba(26, 172, 172, 0.3)",
                  },

                  "&:active": {
                    transform: "translateY(0)",
                    boxShadow: "0 2px 10px rgba(26, 172, 172, 0.2)",
                  },
                },
              }}
            >
              Confirm And Download
            </Button>
          ) : apiSelect.value === "fakenews/printFakeNews" ? (
            <Button
              variant="outlined"
              onClick={handlePrintFakeNews}
              className="stunning-button"
              sx={{
                "&.MuiButton-root": {
                  fontFamily: "'Host Grotesk', sans-serif",
                  fontSize: "14px",
                  fontWeight: "700",
                  padding: "22px 24px",
                  background:
                    "linear-gradient(135deg, #1AACAC 0%, #138B8B 100%)",
                  color: "white",
                  borderRadius: "8px",
                  border: "none",
                  boxShadow: "0 4px 15px rgba(26, 172, 172, 0.2)",
                  transition: "all 0.3s ease",

                  "&:hover": {
                    background:
                      "linear-gradient(135deg, #1AACAC 0%, #138B8B 100%)",
                    transform: "translateY(-2px)",
                    boxShadow: "0 6px 20px rgba(26, 172, 172, 0.3)",
                  },

                  "&:active": {
                    transform: "translateY(0)",
                    boxShadow: "0 2px 10px rgba(26, 172, 172, 0.2)",
                  },
                },
              }}
            >
              Confirm And Downloadddddd
            </Button>
          ) : apiSelect.value === "api/socialSentiments" ? (
            <Button
              variant="outlined"
              onClick={handlePrintSocialsentiments}
              className="stunning-button"
              sx={{
                "&.MuiButton-root": {
                  fontFamily: "'Host Grotesk', sans-serif",
                  fontSize: "14px",
                  fontWeight: "700",
                  padding: "22px 24px",
                  background:
                    "linear-gradient(135deg, #1AACAC 0%, #138B8B 100%)",
                  color: "white",
                  borderRadius: "8px",
                  border: "none",
                  boxShadow: "0 4px 15px rgba(26, 172, 172, 0.2)",
                  transition: "all 0.3s ease",

                  "&:hover": {
                    background:
                      "linear-gradient(135deg, #1AACAC 0%, #138B8B 100%)",
                    transform: "translateY(-2px)",
                    boxShadow: "0 6px 20px rgba(26, 172, 172, 0.3)",
                  },

                  "&:active": {
                    transform: "translateY(0)",
                    boxShadow: "0 2px 10px rgba(26, 172, 172, 0.2)",
                  },
                },
              }}
            >
              Confirm And Download
            </Button>
          ) : (
            "no button available"
          )}
        </div>

        <div className="navbar__right"> </div>
      </nav>

      <main
        className={`${toggleButton ? "mainshow" : "mainhide"}`}
        style={{
          height: "calc(100% - 74px)",
          overflow: "auto",
          backgroundColor: "#FFFFFF",
          /* Hide scrollbar for Chrome, Safari and Opera */
          scrollbarWidth: "none" /* Firefox */,
          msOverflowStyle: "none" /* IE and Edge */,
        }}
      >
        {apiSelect.value === "api/filter" ? (
          <>
            <div ref={pieChartRef} style={{ marginBottom: "60px" }}>
              <h5 style={{ marginLeft: "20px" }}> Languages Analytics </h5>
              <PieChart data={pieChartData.languages} />
            </div>

            <div ref={sentimentPieChartRef} style={{ marginBottom: "10px" }}>
              <h5 style={{ marginLeft: "20px" }}> Sentiment Analytics</h5>
              <PieChart data={pieChartData.sentiment} />
            </div>

            <h5 style={{ marginLeft: "20px" }}> Section Analytics </h5>
            <div
              ref={sectionPieChartRef}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <ReportCylinderChart sectionCounts={pieChartData.section} />
            </div>

            <div
              ref={barChartRef}
              style={{ padding: "80px", width: "80%", marginBottom: "10px" }}
            >
              <h3 style={{ marginLeft: "20px" }}> Platform Analytics</h3>
              <BarChart data={pieChartData.platform} />{" "}
              {/* Use the platform data for the bar chart */}
            </div>

            <div
              ref={wordCloudRef}
              style={{ marginBottom: "10px", width: "50%", marginLeft: "25%" }}
            >
              {sessionID && sessionID.length > 0 ? (
                <SessionWordCloud wordcloudData={pdfTrend ? pdfTrend : []} />
              ) : (
                <ReportWorldCloud wordcloudData={pdfTrend ? pdfTrend : []} />
              )}
            </div>
          </>
        ) : apiSelect.value === "api/socialSentiments" ? (
          <>
            {/* First Chart - Pie Chart for Sentiment Analytics */}
            <div ref={sentimentPieChartRef} style={{ marginBottom: "40px" }}>
              <h5 style={{ marginLeft: "20px" }}> Sentiment Analytics</h5>
              <PieChart data={pieChartData.sentiment} />
            </div>

            {/* Second Chart - Bar Chart for Platform Analytics */}
            <div
              ref={barChartRef}
              style={{ padding: "40px", width: "80%", marginBottom: "40px" }}
            >
              <h3 style={{ marginLeft: "20px" }}> Platform Analytics</h3>
              <BarChart data={pieChartData.platform} />
            </div>

            {/* Third Chart - Word Cloud for Keywords */}

            <div
              ref={wordCloudRef}
              style={{ marginBottom: "10px", width: "50%", marginLeft: "25%" }}
            >
              {sessionID && sessionID.length > 0 ? (
                <SessionWordCloud
                  wordcloudData={
                    pdfTrend && Object.keys(pdfTrend).length > 0 ? pdfTrend : []
                  }
                />
              ) : (
                <ReportWorldCloud wordcloudData={pdfTrend ? pdfTrend : []} />
              )}
            </div>
          </>
        ) : (
          ""
        )}

        <div id="printeablediv" ref={tableRef} style={{ marginBottom: "12vh" }}>
          {serverresponse && serverresponse.length > 0 && (
            <>
              {apiSelect && apiSelect.value === "api/filter" ? (
                <TextAnalysisTable analysisData={serverresponse} />
              ) : apiSelect && apiSelect.value === "api/images" ? (
                // <h1>Image Analysis</h1>
                <ImageAnalysisTable analysisData={serverresponse} />
              ) : apiSelect && apiSelect.value === "news/report" ? (
                <TextAnalysisTableNews analysisData={serverresponse} />
              ) : apiSelect && apiSelect.value === "fakenews/printFakeNews" ? (
                <FakeNewsDataGrid analysisData={serverresponse} />
              ) : apiSelect && apiSelect.value === "api/socialSentiments" ? (
                <SentimentAnalysisTable analysisData={serverresponse} />
              ) : null}
            </>
          )}
        </div>
      </main>
    </div>
  );
};

export default PreviewReport;
